import { useState, useEffect } from "react";
import { RiMenuLine, RiCloseLine } from "react-icons/ri";
import { NAV_LINKS } from "../data/content";
import logo from "../assets/logo.png";
import "./Navbar.css";

const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    scrollTo(id);
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
      <div className="navbar__inner">

        {/* Logo */}
        <button className="navbar__logo" onClick={() => scrollTo("hero")}>
          <span className="navbar__logo-mark">
            <img src={logo} alt="Our Fathers Our Sons logo" className="navbar__logo-img" />
          </span>
          <span className="navbar__logo-name">
            <span className="navbar__logo-name-primary">Our Fathers Our Sons</span>
            <span className="navbar__logo-name-sub">Strengthening Families</span>
          </span>
        </button>

        {/* Desktop links */}
        <ul className="navbar__links">
          {NAV_LINKS.map(({ label, id }) => (
            <li key={id}>
              <button className="navbar__link" onClick={() => handleNav(id)}>
                {label}
              </button>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <button
          className="navbar__cta btn-primary"
         href="https://cal.com/schea91/introcall"
                  onClick={() =>
                    window.open("https://cal.com/schea91/introcall", "_blank")
                  }
        >
          Book A Meeting
        </button>

        {/* Hamburger */}
        <button
          className="navbar__hamburger"
          onClick={() => setMenuOpen((p) => !p)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <RiCloseLine /> : <RiMenuLine />}
        </button>
      </div>

      {/* Mobile drawer */}
      {menuOpen && (
        <div className="navbar__mobile">
          {NAV_LINKS.map(({ label, id }) => (
            <button
              key={id}
              className="navbar__mobile-link"
              onClick={() => handleNav(id)}
            >
              {label}
            </button>
          ))}
          <button
            className="btn-primary navbar__mobile-cta"
            onClick={() => window.open("https://cal.com/schea91/introcall", "_blank")}
          >
            Book Now
          </button>
        </div>
      )}
    </nav>
  );
}